import React, { useEffect, useState } from 'react';
import ExternalSelect from '../ExternalSelect';
import { translate } from '../../services/translate';
import { dashboardSummaryService } from '../../services/central-api/dashboard-summary';
import { useStyles } from 'react-native-unistyles';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    zIndex: number;
    required?: boolean;
}

export default function PlateGroupsDropdown({ value, setValue, zIndex, required }: Props) {
    const { theme } = useStyles();
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);

    async function getPlateGroups() {
        try {
            const plateGroups = await dashboardSummaryService.getPlateGroupsSimplified();

            setItems(plateGroups.map((plateGroup) => {
                return {
                    value: plateGroup.id,
                    label: plateGroup.name,
                    color: theme.colors.backgrounds['BG-4']
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getPlateGroups();
    }, []);

    return (
        <ExternalSelect
            label={translate('linkedGroup')}
            selectedLabel={translate('selectedGroups')}
            required={required}
            items={items}
            setValue={setValue}
            value={value}
            multiple={true}
            zIndex={zIndex}
            onRemove={(items) => setValue(items as number[])}
            badgeTextColor={theme.colors.primary['500']}
            initialSelectedItems={items.filter(item => value.includes(item.value))}
        />
    );
}
